module.exports = __webpack_public_path__ + "static/kassellabs-1280x720-6fd83c0e8beba26ec752e86f10a77752.png";